import React from 'react';
import { makeStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import { BrowserRouter, Route } from 'react-router-dom';
import Belanja from '../Belanja/Belanja';
import Home from '../Home/Home';
import Order from '../Order/Order';
import OrderView from '../OrderView/OrderView';
import OlsLogin from '../OlsLogin/OlsLogin';
import OlsRegister from '../OlsRegister/OlsRegister';
import Product from '../Product/Product';
import ShoppingCart from '../ShoppingCart/ShoppingCart';
import Akun from '../Akun/Akun';
import Post from '../Post/Post';
import Posts from '../Post/Posts';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: window._DEFAULT_COLOR,
    },
    secondary: {
      main: '#E33E7F',
    },
    color: {
      background: '#fafafa',
      footer: '#dedede',
    },
    width: {
      maxWidth: '100%',
      appWidth: '1188px',
    },
  },
});

const useStyles = makeStyles(() => ({
  page: {
    padding: 0,
    maxWidth: theme.palette.width.maxWidth,
    display: 'flex',
    flexDirection: 'column',
  },
}));

const Main = () => {
  const classes = useStyles();
  const { pathname } = window.location;

  const arrPath = pathname.split('/');
  const urlid = (arrPath && arrPath.length >= 2) ? arrPath[2] : '';
  const basePath = (urlid && urlid.length >= 1) ? `/${arrPath[1]}/${arrPath[2]}` : window.location.pathname;


  //const basePath = '/';
  
  return (
    <BrowserRouter basename={basePath}>
      <MuiThemeProvider theme={theme}>
        <Container className={classes.page}>
          <CssBaseline />
          <Route path="/" exact component={Home} />
          <Route path="/login" component={OlsLogin} />
          <Route path="/register" component={OlsRegister} />
          <Route path="/home" component={Home} />
          <Route path="/belanja" component={Belanja} />
          <Route path="/order" exact component={Order} />
          <Route path="/orderview/:uxid" component={OrderView} />
          <Route path="/akun" exact component={Akun} />
          <Route path="/product/:uxid" component={Product} />
          <Route path="/posts" exact component={Posts} />
          <Route path="/post/:permalink" component={Post} />
          <Route path="/shoppingcart" exact component={ShoppingCart} />
        </Container>
      </MuiThemeProvider>
    </BrowserRouter>
  );
};

export default Main;
